function getProductConfig() {
  var result = {};
  var product = CPB.getStore().getState().Product;
  var changes = product.userChanges;
  var panels = Object.keys(changes);
  panels.forEach(function (panelId) {
    var title = "";
    product.panels.forEach(function (panel) {
      if (panel.id === panelId) title = panel.title;
    });
    var panel = {
      title: title,
      categories: {},
    };
    var categories = Object.keys(changes[panelId]);
    categories.forEach(function (categoryId) {
      var catLayer = changes[panelId][categoryId].layer;
      var selectedOption = catLayer?.option;
      var catObj = product.panels
        .find((p) => p.id == panelId)
        .categories.find((c) => c.id == categoryId);
      var category = {
        title: catObj.title,
        options: [],
      };
      catObj.options.forEach(function (option) {
        if (option.id === selectedOption) {
          let title = option.option.data.label;
          let value = (() => {
            if (catObj.type === "font") {
              return catLayer.value;
            } else if (catObj.type === "fileUpload") {
              const res = {};
              catObj.options.forEach((option) => {
                res[option.option.data.label] = option.fileUploadValue;
              });
              return res;
            } else if (catObj.display === "checkbox") {
              let inputs = {};
              title = catObj.title;
              product.layers
                .filter((layer) => layer.category === categoryId)
                .forEach((layer) => {
                  let label = catObj.options.find((o) => o.id == layer.option)
                    .option.data.label;
                  inputs[label] = true;
                });
              return inputs;
            } else if (
              catObj.type === "input" ||
              catObj.type === "multiple" ||
              catObj.type === "dateTime"
            ) {
              let inputs = {};
              Object.keys(changes[panelId][categoryId].options).forEach(
                (opId) => {
                  let label = catObj.options.find((op) => op.id == opId).option
                    .data.label;
                  inputs[label] =
                    changes[panelId][categoryId].options[opId].value;
                }
              );
              if (Object.keys(inputs).length == 1) {
                return changes[panelId][categoryId].value;
              } else {
                title = "";
                return inputs;
              }
            } else if (catObj.type === "dateTime") {
              return changes[panelId][categoryId];
            } else if (option.option.data.value) {
              return option.option.data.value;
            }
          })();
          category.options.push({
            title: title,
            sku: option.sku,
            value: value,
          });
        }
      });
      panel.categories[categoryId] = category;
    });
    result[panelId] = panel;
  });
  return result;
}

//CPB product was mounted:

document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", function (event) {
  console.log("CPB_ON_PRODUCT_MOUNTED");
  // Find the button with class 'cpb-next-tab-button'
  const nextTabButton = document.querySelector(
    '.cpb-next-tab-button[data-intro="Advance To Next Tab"]'
  );
  // Find the button with class 'cpb-next-tab-button'
  const prevTabButton = document.querySelector(
    '.cpb-next-tab-button[data-intro="Advance To Prev Tab"]'
  );

  // Find the element with class 'cpb-panels-tabs'
  const panelsTabs = document.querySelector(".react-tabs__tab-list");

  // Append the 'cpb-next-tab-button' button to the 'cpb-panels-tabs'
  if (nextTabButton && panelsTabs) {
    panelsTabs.after(nextTabButton);
  }

  // Append the 'cpb-next-tab-button' button to the 'cpb-panels-tabs'
  if (prevTabButton && panelsTabs) {
    panelsTabs.after(prevTabButton);
  }

  const connectcustomproductbuilder = document.querySelector(
    ".connectcustomproductbuilder"
  );
  const addtocartcontainer = document.querySelector(
    ".cpb-product-actions-container"
  );
  const triggergetaquote = document.querySelector(".triggergetaquote");

  // Append the 'cpb-next-tab-button' button to the 'cpb-panels-tabs'
  if (connectcustomproductbuilder && addtocartcontainer) {
    addtocartcontainer.after(connectcustomproductbuilder);
  }
  if (triggergetaquote && addtocartcontainer) {
    addtocartcontainer.after(triggergetaquote);
  }
});
//An option was updated:

document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", function (event) {
  console.log("CPB_ON_OPTIONS_UPDATE");
  //console.log(getProductConfig());
  // Loop through all keys in the object
  var obj = getProductConfig();
  var objresult = [];
  if (Object.keys(obj).length > 3) {
    Object.keys(obj).forEach(function (key) {
      let resvalue = "";
      // Check if the 'title' exists at the first level

      if (obj[key].title) {
        resvalue = resvalue + obj[key].title;
        //console.log(obj[key].title); // Output titles like "Select Eid Design", "Step 3"
      }
      // Check if 'options' exists, and if so, loop through options to find the title
      var objcategory = obj[key].categories;
       //console.log(objcategory);
      if (objcategory) {
        Object.keys(objcategory).forEach(function (key2) {
          resvalue = resvalue + " - " + objcategory[key2].title;
          if( objcategory[key2].options[0].title == 'Upload Your Own Design' ){
            document.getElementById("uploadeddesigninput").value = objcategory[key2].options[0].value['Upload Your Own Design'];
          } else {
              if (objcategory[key2].options[0].title) {
                resvalue = resvalue + " - " + objcategory[key2].options[0].title;
              } else {
                if (typeof objcategory[key2].options[0].value === "object") {
                  let valueObj = objcategory[key2].options[0].value;
                  Object.keys(valueObj).forEach(function (key3) {
                    if (valueObj[key3]) {
                      resvalue = resvalue + " - " + key3 + " - " + valueObj[key3];
                    }
                  });
                } else {
                  resvalue = resvalue + " - " + objcategory[key2].options[0].value;
                }
              }
          }

        });
      }
      objresult[obj[key].title] = resvalue;
    });
    console.log(objresult);
    console.log( typeof objresult );
    console.log( Object.keys(objresult).length );
    if ( Object.keys(objresult).length > 0) {
      const ordered = Object.keys(objresult).sort().reduce(
          (obj, key) => { 
            obj[key] = objresult[key]; 
            return obj;
          }, 
          {}
        );
        let inputval = '';
        Object.keys(ordered).forEach(function (key,index) {
          if( index > 0 ){
            inputval = inputval + ', ' + ordered[key];
          }else{
            inputval = inputval  + ordered[key];
          }
          
        });
      document.getElementById("enquireforinput").value = inputval;
    }
  }
});
//An option was selected:

document.body.addEventListener(
  "PRODUCT_BUILDER_OPTION_ACTIVATE",
  function (event) {
    console.log("PRODUCT_BUILDER_OPTION_ACTIVATE");
  }
);
//An option was deselected:

document.body.addEventListener(
  "PRODUCT_BUILDER_OPTION_DEACTIVATE",
  function (event) {
    console.log("PRODUCT_BUILDER_OPTION_DEACTIVATE");
  }
);
//Step changed:

document.body.addEventListener("CPB_ON_UPDATE_CURRENT_TAB", function (event) {
  console.log("CPB_ON_UPDATE_CURRENT_TAB");
  ///console.log(getProductConfig());
  // Select the input element
  const numberInput = document.querySelector(".cpb-quantity-value");
  const numberInputdecrease = document.querySelector(
    ".cpb-quantity-button-decrease"
  );
  const numberInputincrease = document.querySelector(
    ".cpb-quantity-button-increase"
  );

  function showGetQuote() {
    let elements = document.getElementsByClassName("triggergetaquote");
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.display = "flex";
    }
    let elements2 = document.getElementsByClassName(
      "cpb-product-actions-container"
    );
    for (let i = 0; i < elements2.length; i++) {
      elements2[i].style.display = "none";
    }
    // document.getElementById( 'quote-form' ).style.display = 'none';
  }
  function hideGetQuote() {
    let elements = document.getElementsByClassName("triggergetaquote");
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.display = "none";
    }
    let elements2 = document.getElementsByClassName(
      "cpb-product-actions-container"
    );
    for (let i = 0; i < elements2.length; i++) {
      elements2[i].style.display = "block";
    }
    document.getElementById("quote-form").style.display = "none";
  }

  // Add an event listener for 'change' event
  numberInput.addEventListener("change", function () {
    // Get the value of the input when it changes
    let inputValue = numberInput.value;

    if (inputValue > 49) {
      showGetQuote();
    } else {
      hideGetQuote();
    }
  });

  numberInputdecrease.addEventListener("click", function () {
    // Get the value of the input when it changes
    let inputValue = parseInt(numberInput.value) - 1;
    ///alert(inputValue);
    if (inputValue > 49) {
      showGetQuote();
    } else {
      hideGetQuote();
    }
  });
  numberInputincrease.addEventListener("click", function () {
    // Get the value of the input when it changes
    let inputValue = parseInt(numberInput.value) + 1;
    ///alert(inputValue);
    if (inputValue > 49) {
      showGetQuote();
    } else {
      hideGetQuote();
    }
  });

  const triggergetaquote = document.querySelector(".triggergetaquote");
  triggergetaquote.addEventListener("click", function () {
    document.getElementById("quote-form").style.display = "block";
    triggergetaquote.style.display = "none";
  });
});
//Stock chunk was loaded (bundle builder mode)

document.body.addEventListener("STOCK_CHUNK_LOADED", function (event) {
  console.log("STOCK_CHUNK_LOADED");
});
///Stock was synchronized, options mounted:

document.body.addEventListener("STOCK_SYNCHRONIZED", function (event) {
  console.log("STOCK_SYNCHRONIZED");
});
//View changed:

document.body.addEventListener("CPB_ON_UPDATE_CURRENT_VIEW", function (event) {
  console.log("CPB_ON_UPDATE_CURRENT_VIEW");
});
///Konva is ready:

document.body.addEventListener("CPB_ON_KONVA_READY", function (event) {
  console.log("CPB_ON_KONVA_READY");
});
///Layer was rendered:

document.body.addEventListener("CPB_ON_RENDER_LAYERS", function (event) {
  console.log("CPB_ON_RENDER_LAYERS");
});

///Before added to cart:

document.body.addEventListener("before-add-to-cart", function (event) {
  console.log("before-add-to-cart");
});
///Product was added to cart:

document.addEventListener("cpb-add-to-cart", function (event) {
  console.log("cpb-add-to-cart");
});
